import { buildMock } from 'utils'

export default buildMock({
  isExact: true,
  params: {
    id: 'ABC',
    section: null,
  },
  path: '/',
  url: '/',
})
